import React, { useEffect, useRef } from "react";
import c3 from "c3";
import "c3/c3.css";

// Envoltorio de c3: genera la gráfica con `config` y la destruye al desmontar
// o cuando cambian los datos.
export default function C3Chart({ config, height = 280, label }) {
    const chartRef = useRef(null);

    useEffect(() => {
        if (!config || !chartRef.current) return undefined;
        const chart = c3.generate({
            bindto: chartRef.current,
            size: { height },
            padding: { right: 16 },
            point: { r: 0, focus: { expand: { r: 4 } } },
            grid: { y: { show: true } },
            transition: { duration: 0 },
            ...config,
        });
        return () => chart.destroy();
    }, [config, height]);

    return <div className="mk-chart" ref={chartRef} role="img" aria-label={label} />;
}
